import { render } from "./PMSSettings.vue?vue&type=template&id=e08778ca"
import script from "./PMSSettings.vue?vue&type=script&lang=js"
export * from "./PMSSettings.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__